module.exports = __webpack_public_path__ + "img/boat.fbb5c281.jpg";